import React from 'react';
import Chip from '@mui/material/Chip';

/**
 * Chip de situação no padrão do Admin Geral (texto colorido sobre fundo claro).
 * @param {{ info: { label: string, color: string, bg: string }, size?: 'small'|'medium', sx?: Object }} props
 */
function StatusChip({ info, size = 'small', sx }) {
  if (!info) return null;
  return (
    <Chip
      size={size}
      label={info.label}
      sx={{ color: info.color, backgroundColor: info.bg, fontWeight: 600, ...sx }}
    />
  );
}

export default StatusChip;
